module.exports = __webpack_public_path__ + "static/media/baggage-checkin.e9acd2f4.png";